
/*
 * ! @chakra-ui/vue v0.12.0 by Jonathan Bakebwa @codebender828
 * MIT License
 * https://github.com/chakra-ui/chakra-ui-vue
 */

import { R as createStyledAttrsMixin } from './index-2557a15f.js';
import './chakra-ui-styled-system.esm-36097b89.js';
import '@emotion/css';
import 'vue';
import './color-mode-observer-d3e4ca7f.js';
import { u as useBadgeStyle } from './badge.styles-79cfa452.js';

/**
 * Hey! Welcome to @chakra-ui/vue Badge
 *
 * The Badge component is used to highlight an item's status for quick recognition.
 *
 * @see Docs     https://vue.chakra-ui.com/badge
 * @see Source   https://github.com/chakra-ui/chakra-ui-vue/blob/master/packages/chakra-ui-core/src/CBadge/CBadge.js
 */
/**
 * CBadge component
 *
 * Used to highlight an item's status for quick recognition.
 *
 * @see Docs https://vue.chakra-ui.com/badge
 */

var CBadge = {
  name: 'CBadge',
  mixins: [createStyledAttrsMixin('CBadge')],
  props: {
    variant: {
      type: String,
      default: 'subtle'
    },
    variantColor: {
      type: String,
      default: 'gray'
    },
    as: {
      type: String,
      default: 'div'
    }
  },
  computed: {
    badgeStyles: function badgeStyles() {
      return useBadgeStyle({
        theme: this.theme,
        colorMode: this.colorMode,
        color: this.variantColor,
        variant: this.variant
      });
    },
    componentStyles: function componentStyles() {
      return Object.assign({}, {
        d: 'inline-block',
        textTransform: 'uppercase',
        fontSize: 'xs',
        fontFamily: 'body',
        px: 1,
        rounded: 'sm',
        fontWeight: 'bold',
        whiteSpace: 'nowrap',
        verticalAlign: 'middle'
      }, this.badgeStyles);
    }
  },
  render: function render(h) {
    return h(this.as, {
      class: this.className,
      attrs: this.computedAttrs
    }, this.$slots.default);
  }
};

export default CBadge;
